export default __webpack_public_path__ + "static/media/featimgthree.192c11e6.svg";